import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AdminDashboardPageService } from '../../pages/main-pages/admin-dashboard-page/admin-dashboard-page.service';
import { AzureService } from '../../shared/services/azure.service';
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-create-company-modal',
  imports: [ReactiveFormsModule, NgIf],
  templateUrl: './create-company-modal.component.html',
  styleUrl: './create-company-modal.component.scss'
})
export class CreateCompanyModalComponent {
  private fb = inject(FormBuilder);
  private dialogRef = inject(MatDialogRef<CreateCompanyModalComponent>);
  private adminService = inject(AdminDashboardPageService);
  private azureService = inject(AzureService);

  isSubmitting = false;

  selectedImageFile: File | null = null;
  imagePreviewUrl: string | null = null;
  imageError: string | null = null;

  companyForm: FormGroup = this.fb.group({
    name: ['', Validators.required],
    industry: ['', Validators.required],
    location: ['', Validators.required],
    website: [''],
    description: [''],
    partnerEmail: ['', Validators.email],
    role: ['', Validators.required],
    institutionCode: ['']
  });

  constructor() {
    this.companyForm.get('role')?.valueChanges.subscribe((role) => {
      const ctrl = this.companyForm.get('institutionCode');
      if (role === 'AGENCY') {
        ctrl?.setValidators([Validators.required]);
      } else {
        ctrl?.clearValidators();
      }
      ctrl?.updateValueAndValidity();
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  onFileSelected(event: Event): void {
    this.imageError = null;
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];

    if (file.size > 2 * 1024 * 1024) {
      this.imageError = 'File is larger than 2 MB.';
      return;
    }

    this.selectedImageFile = file;

    const reader = new FileReader();
    reader.onload = () => (this.imagePreviewUrl = reader.result as string);
    reader.readAsDataURL(file);
  }

  submit(): void {
    if (this.companyForm.invalid || this.isSubmitting) return;
    this.isSubmitting = true;

    const payload = this.companyForm.value;

    this.adminService.createCompany(payload).subscribe({
      next: (createdCompany) => {
        const companyId = createdCompany?.id;

        if (companyId && this.selectedImageFile) {
          this.azureService.updateCompanyImage(companyId, this.selectedImageFile).subscribe({
            next: () => {
              this.isSubmitting = false;
              this.dialogRef.close({ created: true });
            },
            error: (err) => {
              console.error('Error uploading company logo', err);
              this.isSubmitting = false;
              this.dialogRef.close({ created: true });
            }
          });
        } else {
          this.isSubmitting = false;
          this.dialogRef.close({ created: true });
        }
      },
      error: (err) => {
        console.error('Error creating company', err);
        this.isSubmitting = false;
      }
    });
  }
}
